function RealPennedPostCardsIcon() {
    return (
        <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 18.23 16.84">
            <path
                fill="#ffffff"
                d="M8.62,6.51a.2.2,0,0,0,0-.08A.2.2,0,0,1,8.62,6.51Z"
                transform="translate(-1.02 -1.53)"
            />
            <path
                fill="#ffffff"
                d="M10.14,16.28a.13.13,0,0,1-.13-.13V7.91a.13.13,0,0,1,.13-.13.13.13,0,0,1,.13.13v8.24A.13.13,0,0,1,10.14,16.28Z"
                transform="translate(-1.02 -1.53)"
            />
            <rect
                fill="#ffffff"
                x="14.1"
                y="5.9"
                width="2.12"
                height="2.31"
                rx="0.39"
            />
            <path
                fill="#ffffff"
                d="M17.09,12.27H11.84a.13.13,0,0,1-.14-.13.13.13,0,0,1,.14-.13h5.25a.13.13,0,0,1,.13.13A.13.13,0,0,1,17.09,12.27Z"
                transform="translate(-1.02 -1.53)"
            />
            <path
                fill="#ffffff"
                d="M17.09,13.44H11.84a.14.14,0,0,1-.14-.14.13.13,0,0,1,.14-.13h5.25a.13.13,0,0,1,.13.13A.13.13,0,0,1,17.09,13.44Z"
                transform="translate(-1.02 -1.53)"
            />
            <path
                fill="#ffffff"
                d="M17.09,14.56H11.84a.13.13,0,0,1-.14-.13.14.14,0,0,1,.14-.14h5.25a.13.13,0,0,1,.13.14A.13.13,0,0,1,17.09,14.56Z"
                transform="translate(-1.02 -1.53)"
            />
            <g>
                <path
                    fill="#ffffff"
                    d="M10.87,3.08l.29-.47a.4.4,0,0,1,.56-.12.41.41,0,0,1,.13.55l-.28.47.31.19c.21-.39.53-1.19,1-1.09a1.7,1.7,0,0,0-.67-.9,1.76,1.76,0,0,0-1-.16c.34.31-.49,1.18-.58,1.32Z"
                    transform="translate(-1.02 -1.53)"
                />
                <path
                    fill="#ffffff"
                    d="M18.16,5.69h-6.8l.38-.59a3.41,3.41,0,0,0,.2-.32.7.7,0,0,0,.13-.32A.4.4,0,0,0,11.84,4l-.43-.27L11,4.46l-.38.64-.28.44L10,6.12l-.57.94a.41.41,0,0,1-.56.15.41.41,0,0,1-.15-.56v0l.56-.91.36-.58,0,0L10,4.47l.67-1.11-.53-.3a.45.45,0,0,0-.63.15s-.28.51-.68,1.26l-.34.63h0l-.31.58H2.11A1.09,1.09,0,0,0,1,6.78v10.5a1.09,1.09,0,0,0,1.09,1.09h16a1.09,1.09,0,0,0,1.1-1.09V6.78A1.09,1.09,0,0,0,18.16,5.69Zm.1,11.59a.1.1,0,0,1-.11.1h-16a.09.09,0,0,1-.1-.1V6.78a.1.1,0,0,1,.1-.11H7.68L6.74,8.43H3.19a.13.13,0,1,0,0,.26H6.6L6,9.82H3.19a.13.13,0,0,0-.13.13.13.13,0,0,0,.13.13H5.86l-.6,1.12H3.19a.13.13,0,0,0-.13.13.13.13,0,0,0,.13.14H5.12c-.29.55-.51,1-.6,1.12H3.19a.13.13,0,1,0,0,.26H4.45l0,.28L4.18,14h-1a.13.13,0,0,0,0,.26h.92c0,.06,0,.13-.05.19L4,14.84l.08.05-.15.49H3.19a.12.12,0,0,0-.12.12.12.12,0,0,0,.12.12H8.44a.12.12,0,0,0,.12-.12.12.12,0,0,0-.12-.12H4.09l.3-.29.08,0,.32-.26.47-.44.2-.19h3a.13.13,0,0,0,0-.26H5.75a3,3,0,0,1,.39-.33l.34-.51.18-.29H8.44a.13.13,0,0,0,0-.26H6.84l0-.06L7.21,12l.36-.55h.87a.13.13,0,0,0,.13-.14.13.13,0,0,0-.13-.13H7.75L7.9,11l.59-.9A.13.13,0,0,0,8.57,10c.13-.21.27-.41.41-.62l1.07-1.65.62-.94.05-.07h7.43a.11.11,0,0,1,.11.11Z"
                    transform="translate(-1.02 -1.53)"
                />
            </g>
        </svg>
    )
}

export default RealPennedPostCardsIcon
